import React, { useState } from 'react'
import CustomModal from '../CustomModal'
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';

const BasicPackageRestrictionModal = ({ open, setOpen }) => {
    const { t } = useTranslation()

    return (
        <CustomModal
            title={<span>{t("messages.basicPackageTitle")}</span>}
            visible={open}
            className="my-custom-modal"
            handleCancel={() => setOpen(false)}
            // handleOk={handleDeleteUser}
            width={400}
            footer={false}
        >
            <span className="font-color">{t("messages.basicPackageMessage")}</span>
            <br />
            <br />
            <span style={{ fontSize: '12px', color: '#808080' }}>{t("messages.purchaseNote")}</span>
            <div className="figma-modal-footer">
                <Button
                    onClick={() => setOpen(false)}
                    className="figma-cancel-btn"
                >
                    {t("common.cancel")}
                </Button>
                <a
                    href="https://play.google.com/store/apps/details?id=com.cloudstorage.mycloud.storagespace.cloudapp"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Button
                        type="primary"
                        onClick={(e) => { }}
                        className="figma-delete-btn"
                    >
                        {t("common.downloadApp")}
                    </Button>
                </a>
            </div>
        </CustomModal>
    )
}


export default BasicPackageRestrictionModal


